// src/pages/CoverageDetailPage.jsx
import { useParams, Navigate } from 'react-router-dom';
import { coverageItems } from '../data/coverage';
import { servicesData } from '../data/services';
import { DetailPageTemplate } from '../components/templates/DetailPageTemplate';
import { Seo } from '../components/Seo';
import { serviceJsonLd, breadcrumbJsonLd } from '../lib/structuredData';

export function CoverageDetailPage() {
  const { slug } = useParams();
  const item = coverageItems.find((c) => c.slug === slug);

  if (!item) {
    return <Navigate to="/" replace />;
  }

  const matchedService = servicesData.find((s) => s.slug === item.slug);

  return (
    <>
      <Seo
        title={`${item.name} 대응 — medilawyer`}
        description={item.detailIntro}
        path={`/coverage/${item.slug}`}
        jsonLd={[
          serviceJsonLd({
            name: item.name,
            description: item.detailIntro,
            path: `/coverage/${item.slug}`,
          }),
          breadcrumbJsonLd([
            { name: '홈', path: '/' },
            { name: '대응분야', path: '/#coverage' },
            { name: item.name, path: `/coverage/${item.slug}` },
          ]),
        ]}
      />
      <DetailPageTemplate
        eyebrow="Problem"
        title={item.pain}
        intro={item.detailIntro}
        hero={{ img: item.img, alt: item.name }}
        sections={item.detailSections}
        ctaLabel={item.ctaLabel}
        serviceContext={`coverage:${item.slug}`}
        backHref="/#coverage"
        relatedLink={
          matchedService
            ? {
                href: `/services/${matchedService.slug}`,
                label: `이 문제를 해결하는 서비스: ${matchedService.cat} 보기`,
              }
            : undefined
        }
      />
    </>
  );
}
